import React, { useState } from 'react';
import styled from '@/styles';
import { GetJobQuery } from '@/types/graphql';
import ShareQRCodeModal from '../ShareQRCodeModal';
import ShiftQRCodeModal from '../ShiftQRCodeModal';

interface ShiftQRButtonProps {
  job?: GetJobQuery['job'];
  jobDetails?: any;
  onClick?: () => void;
  className?: string;
  style?: React.CSSProperties;
}

const QRButton = styled('button', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '6px',
  padding: '8px 16px',
  borderRadius: '8px',
  border: '1px solid #46a735',
  backgroundColor: '#46a735',
  color: 'white',
  cursor: 'pointer',
  fontSize: '14px',
  fontWeight: '600',
  transition: 'all 0.2s ease',
  minWidth: '130px',
  height: '36px',
  whiteSpace: 'nowrap',
  flexShrink: 0,
  top: '11px',

  '&:hover': {
    backgroundColor: '#45A735',
    borderColor: '#45A735',

    '& svg': {
      fill: 'white',
    },
  },

  '&:active': {
    transform: 'translateY(1px)',
  },

  '@phoneOnly': {
    fontSize: '12px',
    padding: '6px 10px',
    minWidth: '110px',
    height: '32px',
    gap: '4px',
  },
});

const QRIcon = styled('svg', {
  width: '16px',
  height: '16px',
  fill: 'white',
  transition: 'fill 0.2s ease',

  '@phoneOnly': {
    width: '14px',
    height: '14px',
  },
});

const ShiftQRButton: React.FC<ShiftQRButtonProps> = ({
  job,
  jobDetails,
  onClick,
  className,
  style,
}) => {
  const [showQRModal, setShowQRModal] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      // Default behavior - open QR modal
      setShowQRModal(true);
    }
  };

  const handleShareClick = () => {
    setShowQRModal(false);
    setShowShareModal(true);
  };

  const handleShareComplete = () => {
    setShowShareModal(false);
    // Optionally show success message or return to QR modal
  };

  const handleCloseModals = () => {
    setShowQRModal(false);
    setShowShareModal(false);
  };

  return (
    <>
      <QRButton onClick={handleClick} className={className} style={style}>
        <QRIcon viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path d="M3 11V3H11V11H3ZM5 9H9V5H5V9ZM3 21V13H11V21H3ZM5 19H9V15H5V19ZM13 3V11H21V3H13ZM19 9H15V5H19V9ZM19 13H21V15H19V13ZM13 13H15V15H13V13ZM15 15H17V17H15V15ZM13 17H15V19H13V17ZM15 19H17V21H15V19ZM17 17H19V19H17V17ZM19 19H21V21H19V19ZM17 13H19V15H17V13Z" />
        </QRIcon>
        Shift QR Code
      </QRButton>

      {job && (
        <>
          <ShiftQRCodeModal
            isOpen={showQRModal}
            onClose={handleCloseModals}
            onShareClick={handleShareClick}
            job={job}
            jobDetails={jobDetails}
          />
          <ShareQRCodeModal
            isOpen={showShareModal}
            onClose={handleCloseModals}
            onShare={handleShareComplete}
            job={job}
          />
        </>
      )}
    </>
  );
};

export default ShiftQRButton;
